import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";

const CityCombos = ({ city, popularServices }) => (
	<Box component={"section"} pt={4} pb={20}>
		<Container maxWidth="md">
			<Box
				component={"h1"}
				fontSize={{ xs: 24, sm: 32 }}
				fontWeight={700}
				mt={0}
				mb={10}
			>
				{`${city.name
					.toLowerCase()
					.ucFirst()}, ${city.state.toUpperCase()} services`}
			</Box>
			<div>
				<Grid container spacing={4}>
					{popularServices.map((popularService) => (
						<Grid item xs={12} sm={6} md={4} key={popularService._id}>
							<Link
								href={`${city.url}${popularService.url}/`}
								color={"primary"}
							>
								{popularService.phrase.ucFirst()}
							</Link>
						</Grid>
					))}
				</Grid>
			</div>
		</Container>
	</Box>
);

CityCombos.propTypes = {
	city: PropTypes.shape({
		name: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
	}).isRequired,

	popularServices: PropTypes.arrayOf(
		PropTypes.shape({
			_id: PropTypes.string.isRequired,
			phrase: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default CityCombos;
